import { Reducer } from 'redux';
import { UsersState, UsersTypes } from './types';

export const INITIAL_STATE: UsersState = {
  firebaseData: {},
  webUsersList: [],
  webUsersListFromModules: [],
  webUserData: {
    id: '',
    name: '',
    email: '',
    photoUrl: '',
    createdAt: '',
    updatedAt: '',
    transportOperatorId: '',
    TransportOperators: [],
    isUpdate: false,
  },

  appUsersList: [],
  appUsersListFull: [],
  appUsersMergeList: [],
  selectedSearchUser: [],
  appUserData: {
    id: '',
    shortId: '',
    name: '',
    nickname: '',
    email: '',
    document: '',
    phone: '',
    obs: '',
    sex: '',
    createdAt: '',
    expires: '',
    updatedAt: '',
    deleted: false,
    photoUrl: null,
    birthplace: null,
    birthdate: null,
    Denylists: [],
    Companies: [],
    Schools: [],
    Profiles: [],
    UserProfiles: [],
    UserDocuments: [],
    UserComments: [],
    ProductTransactions: [],
  },
  appUserMergeData: {
    id: '',
    shortId: '',
    name: '',
    nickname: '',
    email: '',
    document: '',
    phone: '',
    obs: '',
    sex: '',
    createdAt: '',
    expires: '',
    updatedAt: '',
    deleted: false,
    photoUrl: null,
    birthplace: null,
    birthdate: null,
    Denylists: [],
    Companies: [],
    Schools: [],
    Profiles: [],
    UserProfiles: [],
    UserDocuments: [],
    UserComments: [],
    ProductTransactions: [],
  },
  appUserInCompanyData: {
    id: '',
    shortId: '',
    name: '',
    nickname: '',
    email: '',
    document: '',
    phone: '',
    obs: '',
    sex: '',
    createdAt: '',
    expires: '',
    updatedAt: '',
    deleted: false,
    photoUrl: null,
    birthplace: null,
    birthdate: null,
    Denylists: [],
    Companies: [],
    Schools: [],
    Profiles: [],
    UserProfiles: [],
    UserDocuments: [],
    UserComments: [],
    ProductTransactions: [],
  },
  appUserDocumentData: {
    userId: '',
    document: '',
    photoUrl: null,
    type: 0,
  },
  appUserCommentData: {
    id: '',
    comment: '',
    attachmentPhoto: '',
    userId: '',
    createdAt: '',
    TransportSupervisor: {
      name: '',
    },
  },
  appUserSettingsData: {
    id: '',
    operationMethods: null,
    transportOperatorId: '',
    createdAt: '',
    updatedAt: '',
  },
  appUserCheckFacialList: [],
  mergeAccountsError: false,
  totalCount: 0,
  totalCountMerge: 0,
  email: '',
  mfaEnabled: false,
  mfaResolver: null,
  mfaPending: false,
  mfaError: '',
  currentUser: null,
  totpSecret: null,
  isEnrolling: false,
  isVerifying: false,
  isVerifyingEnroll: false,
  error: false,
  loading: false,
  created: false,
};

const reducer: Reducer<UsersState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // CASES LOGIN
    case UsersTypes.LOGIN_REQUEST:
      return { ...state, loading: true };
    case UsersTypes.LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        firebaseData: action.payload.user,
      };
    case UsersTypes.LOGIN_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        firebaseData: INITIAL_STATE.firebaseData,
      };

    case UsersTypes.ENROLL_MFA_REQUEST:
      return {
        ...state,
        isEnrolling: true,
        error: false,
        loading: true,
      };

    case UsersTypes.ENROLL_MFA_SUCCESS:
      return {
        ...state,
        isEnrolling: false,
        totpSecret: action.payload,
        error: false,
        loading: false,
      };

    case UsersTypes.ENROLL_MFA_FAILURE:
      return {
        ...state,
        loading: false,
        isEnrolling: false,
        error: action.payload.error,
      };

    case UsersTypes.VERIFY_MFA_ENROLL_REQUEST:
      return {
        ...state,
        isVerifyingEnroll: true,
        error: false,
        loading: true,
        mfaError: '',
      };

    case UsersTypes.VERIFY_MFA_ENROLL_SUCCESS:
      return {
        ...state,
        isVerifyingEnroll: action.payload.isEnrolled,
        firebaseData: action.payload.user,
        totpSecret: null,
        mfaResolver: null,
        error: false,
        loading: false,
        mfaError: '',
      };

    case UsersTypes.VERIFY_MFA_ENROLL_FAILURE:
      return {
        ...state,
        loading: false,
        isVerifyingEnroll: false,
        error: action.payload.error,
        mfaError: action.payload.error,
      };

    case UsersTypes.UNENROLL_MFA_REQUEST:
      return {
        ...state,
        mfaPending: true,
        mfaError: '',
        error: false,
        loading: true,
      };

    case UsersTypes.UNENROLL_MFA_SUCCESS:
      return {
        ...state,
        mfaPending: false,
        mfaResolver: action.payload.resolver,
        firebaseData: action.payload.user,
        mfaEnabled: false,
        error: false,
        loading: false,
      };

    case UsersTypes.UNENROLL_MFA_FAILURE:
      return {
        ...state,
        mfaPending: false,
        mfaError: action.payload.error,
        loading: false,
        error: action.payload.error,
      };

    case UsersTypes.VERIFY_MFA_REQUEST:
      return {
        ...state,
        mfaPending: true,
        mfaError: '',
        error: false,
        loading: true,
      };

    case UsersTypes.VERIFY_MFA_SUCCESS:
      return {
        ...state,
        mfaEnabled: true,
        mfaPending: false,
        mfaResolver: null,
        error: false,
        loading: false,
      };

    case UsersTypes.VERIFY_MFA_FAILURE:
      return {
        ...state,
        mfaPending: false,
        mfaError: action.payload.error,
        loading: false,
        error: action.payload.error,
      };

    case UsersTypes.SET_MFA_RESOLVER:
      return {
        ...state,
        mfaEnabled: true,
        mfaPending: false,
        mfaResolver: action.payload.resolver,
        error: false,
        loading: false,
      };

    // CASES LOGIN
    case UsersTypes.LOGOUT_REQUEST:
      return { ...state, loading: true, error: false };
    case UsersTypes.LOGOUT_SUCCESS:
      return { ...INITIAL_STATE, mfaEnabled: false };
    case UsersTypes.LOGOUT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        firebaseData: INITIAL_STATE.firebaseData,
      };

    // CASES FORGOT PASSWORD
    case UsersTypes.FORGOT_PASSWORD_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        firebaseData: INITIAL_STATE.firebaseData,
      };
    case UsersTypes.FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        firebaseData: INITIAL_STATE.firebaseData,
      };
    case UsersTypes.FORGOT_PASSWORD_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        firebaseData: INITIAL_STATE.firebaseData,
      };

    // CASES CREATE PASSWORD
    case UsersTypes.CREATE_PASSWORD_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case UsersTypes.CREATE_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
      };
    case UsersTypes.CREATE_PASSWORD_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    // CASES RESET VERIFY PASSWORD
    case UsersTypes.RESET_PASSWORD_VERIFY_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        firebaseData: INITIAL_STATE.firebaseData,
      };

    case UsersTypes.RESET_PASSWORD_VERIFY_SUCCESS:
      return {
        ...state,
        loading: true,
        error: false,
        firebaseData: INITIAL_STATE.firebaseData,
        email: action.payload.email,
      };

    case UsersTypes.RESET_PASSWORD_VERIFY_FAILURE:
      return {
        ...state,
        loading: true,
        error: false,
        firebaseData: INITIAL_STATE.firebaseData,
      };

    // CASES RESET PASSWORD
    case UsersTypes.RESET_PASSWORD_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        firebaseData: INITIAL_STATE.firebaseData,
      };
    case UsersTypes.RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        firebaseData: INITIAL_STATE.firebaseData,
      };
    case UsersTypes.RESET_PASSWORD_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        firebaseData: INITIAL_STATE.firebaseData,
      };

    // CASES LIST_WEB_USERS
    case UsersTypes.LIST_WEB_USERS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        webUsersList: INITIAL_STATE.webUsersList,
      };
    case UsersTypes.LIST_WEB_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        webUsersList: action.payload.webUsersList,
        totalCount: action.payload.totalCount,
      };
    case UsersTypes.LIST_WEB_USERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        webUsersList: INITIAL_STATE.webUsersList,
      };

    // CASES LIST_FROM_MODULES_WEB_USERS
    case UsersTypes.LIST_FROM_MODULES_WEB_USERS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        webUsersListFromModules: INITIAL_STATE.webUsersListFromModules,
      };
    case UsersTypes.LIST_FROM_MODULES_WEB_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        webUsersListFromModules: action.payload.webUsersListFromModules,
        totalCount: action.payload.totalCount,
      };
    case UsersTypes.LIST_FROM_MODULES_WEB_USERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        webUsersListFromModules: INITIAL_STATE.webUsersListFromModules,
      };

    // CASES FILTER_WEB_USERS
    case UsersTypes.FILTER_WEB_USERS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        webUsersList: INITIAL_STATE.webUsersList,
      };
    case UsersTypes.FILTER_WEB_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        webUsersList: action.payload.webUsersList,
        totalCount: action.payload.totalCount,
      };
    case UsersTypes.FILTER_WEB_USERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        webUsersList: INITIAL_STATE.webUsersList,
      };

    // CASES FILTER APP USERS LIST
    case UsersTypes.FILTER_APP_USERS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        appUsersList: INITIAL_STATE.appUsersList,
      };
    case UsersTypes.FILTER_APP_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        appUsersList: action.payload.appUsersList,
        totalCount: action.payload.totalCount,
      };
    case UsersTypes.FILTER_APP_USERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        appUsersList: INITIAL_STATE.appUsersList,
      };

    // CASES CREATE_WEB_USER
    case UsersTypes.CREATE_WEB_USER_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        webUserData: INITIAL_STATE.webUserData,
      };
    case UsersTypes.CREATE_WEB_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        webUserData: action.payload.webUserData,
      };
    case UsersTypes.CREATE_WEB_USER_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        webUserData: INITIAL_STATE.webUserData,
      };

    // CASES GET_WEB_USER
    case UsersTypes.GET_WEB_USER_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        webUserData: INITIAL_STATE.webUserData,
      };
    case UsersTypes.GET_WEB_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        webUserData: action.payload.webUserData,
      };
    case UsersTypes.GET_WEB_USER_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        webUserData: INITIAL_STATE.webUserData,
      };

    // CASES UPDATE_WEB_USER
    case UsersTypes.UPDATE_WEB_USER_REQUEST:
      return { ...state, loading: true, error: false };
    case UsersTypes.UPDATE_WEB_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        webUserData: action.payload.webUserData,
      };
    case UsersTypes.UPDATE_WEB_USER_FAILURE:
      return { ...state, loading: false, error: true };

    // CASES DELETE_WEB_USER
    case UsersTypes.DELETE_WEB_USER_REQUEST:
      return { ...state, loading: true, error: false };
    case UsersTypes.DELETE_WEB_USER_SUCCESS:
      return { ...state, loading: false, error: false };
    case UsersTypes.DELETE_WEB_USER_FAILURE:
      return { ...state, loading: false, error: true };

    // CASES LIST_APP_USERS
    case UsersTypes.LIST_APP_USERS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        ...(!action.payload?.isCsvFull && {
          appUsersList: INITIAL_STATE.appUsersList,
        }),
      };
    case UsersTypes.LIST_APP_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        ...(!action.payload?.isCsvFull && {
          appUsersList: action.payload.appUsersList,
        }),
        ...(action.payload?.isCsvFull && {
          appUsersListFull: action.payload.appUsersList,
        }),
        totalCount: action.payload.totalCount,
      };
    case UsersTypes.LIST_APP_USERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        appUsersList: INITIAL_STATE.appUsersList,
      };

    // CASES LIST_APP_USERS_MERGE
    case UsersTypes.LIST_APP_USERS_MERGE_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        appUsersMergeList: INITIAL_STATE.appUsersMergeList,
      };
    case UsersTypes.LIST_APP_USERS_MERGE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        appUsersMergeList: action.payload.appUsersMergeList,
        totalCountMerge: action.payload.totalCountMerge,
      };
    case UsersTypes.LIST_APP_USERS_MERGE_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        appUsersMergeList: INITIAL_STATE.appUsersMergeList,
      };

    // CASES FILTER APP USERS MERGE LIST
    case UsersTypes.FILTER_APP_USERS_MERGE_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        appUsersMergeList: INITIAL_STATE.appUsersMergeList,
      };
    case UsersTypes.FILTER_APP_USERS_MERGE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        appUsersMergeList: action.payload.appUsersMergeList,
        totalCountMerge: action.payload.totalCountMerge,
      };
    case UsersTypes.FILTER_APP_USERS_MERGE_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        appUsersMergeList: INITIAL_STATE.appUsersMergeList,
      };

    // CASES APP_USER_MERGE
    case UsersTypes.APP_USER_MERGE_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        appUsersMergeList: INITIAL_STATE.appUsersMergeList,
      };
    case UsersTypes.APP_USER_MERGE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        appUsersMergeList: action.payload.appUsersMergeList,
        totalCountMerge: action.payload.totalCountMerge,
      };
    case UsersTypes.APP_USER_MERGE_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        appUsersMergeList: INITIAL_STATE.appUsersMergeList,
      };

    // SET APP USER MERGE ERROR
    case UsersTypes.SET_APP_USER_MERGE_ERROR:
      return { ...state, mergeAccountsError: action.payload };

    // CASES SET_SELECTED_SEARCH_USER
    case UsersTypes.SET_SELECTED_SEARCH_USER:
      return {
        ...state,
        loading: false,
        error: false,
        selectedSearchUser: action.payload.selectedSearchUser,
      };

    // CASES GET_APP_USER
    case UsersTypes.GET_APP_USER_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        appUserData: INITIAL_STATE.appUserData,
      };
    case UsersTypes.GET_APP_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        appUserData: action.payload.appUserData,
      };
    case UsersTypes.GET_APP_USER_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        appUserData: INITIAL_STATE.appUserData,
      };

    // CASES GET_APP_USER_MERGE
    case UsersTypes.GET_APP_USER_MERGE_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        appUserMergeData: INITIAL_STATE.appUserMergeData,
      };
    case UsersTypes.GET_APP_USER_MERGE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        appUserMergeData: action.payload.appUserMergeData,
      };
    case UsersTypes.GET_APP_USER_MERGE_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        appUserMergeData: INITIAL_STATE.appUserMergeData,
      };

    // GET_APP_USER_FROM_DOCUMENT
    case UsersTypes.GET_APP_USER_FROM_DOCUMENT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        appUserData: INITIAL_STATE.appUserData,
      };
    case UsersTypes.GET_APP_USER_FROM_DOCUMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        appUserData: action.payload.appUserData,
      };
    case UsersTypes.GET_APP_USER_FROM_DOCUMENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        appUserData: INITIAL_STATE.appUserData,
      };

    // CASES CREATE_APP_USER
    case UsersTypes.CREATE_APP_USER_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        appUserData: INITIAL_STATE.appUserData,
      };
    case UsersTypes.CREATE_APP_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        appUserData: action.payload.appUserData,
        created: true,
      };
    case UsersTypes.CREATE_APP_USER_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        appUserData: INITIAL_STATE.appUserData,
      };

    // CASES UPDATE_APP_USER
    case UsersTypes.UPDATE_APP_USER_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case UsersTypes.UPDATE_APP_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        appUserData: action.payload.appUserData,
      };
    case UsersTypes.UPDATE_APP_USER_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    // CASES DELETE_APP_USER
    case UsersTypes.DELETE_APP_USER_REQUEST:
      return { ...state, loading: true, error: false };
    case UsersTypes.DELETE_APP_USER_SUCCESS:
      return { ...state, loading: false, error: false };
    case UsersTypes.DELETE_APP_USER_FAILURE:
      return { ...state, loading: false, error: true };

    // CASES USER PROFILE TOGGLE
    case UsersTypes.USER_PROFILE_TOGGLE_REQUEST:
      return { ...state, loading: true, error: false };
    case UsersTypes.USER_PROFILE_TOGGLE_SUCCESS:
      return { ...state, loading: false, error: false };
    case UsersTypes.USER_PROFILE_TOGGLE_FAILURE:
      return { ...state, loading: false, error: true };

    // CASES USER PROFILE RENEW
    case UsersTypes.USER_PROFILE_RENEW_REQUEST:
      return { ...state, loading: true, error: false };
    case UsersTypes.USER_PROFILE_RENEW_SUCCESS:
      return { ...state, loading: false, error: false };
    case UsersTypes.USER_PROFILE_RENEW_FAILURE:
      return { ...state, loading: false, error: true };

    // CASES CREATE_APP_USER_DOCUMENT
    case UsersTypes.CREATE_APP_USER_DOCUMENT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        appUserDocumentData: INITIAL_STATE.appUserDocumentData,
      };
    case UsersTypes.CREATE_APP_USER_DOCUMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        appUserDocumentData: action.payload.appUserDocumentData,
      };
    case UsersTypes.CREATE_APP_USER_DOCUMENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        appUserDocumentData: INITIAL_STATE.appUserDocumentData,
      };

    // CASES UPDATE_APP_USER_DOCUMENT
    case UsersTypes.UPDATE_APP_USER_DOCUMENT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        appUserDocumentData: INITIAL_STATE.appUserDocumentData,
      };
    case UsersTypes.UPDATE_APP_USER_DOCUMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        appUserDocumentData: action.payload.appUserDocumentData,
      };
    case UsersTypes.UPDATE_APP_USER_DOCUMENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        appUserDocumentData: INITIAL_STATE.appUserDocumentData,
      };

    // CASES DELETE_APP_USER_DOCUMENT
    case UsersTypes.DELETE_APP_USER_DOCUMENT_REQUEST:
      return { ...state, loading: true, error: false };
    case UsersTypes.DELETE_APP_USER_DOCUMENT_SUCCESS:
      return { ...state, loading: false, error: false };
    case UsersTypes.DELETE_APP_USER_DOCUMENT_FAILURE:
      return { ...state, loading: false, error: true };

    // CASES CREATE_APP_USER_COMMENT
    case UsersTypes.CREATE_APP_USER_COMMENT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        appUserCommentData: INITIAL_STATE.appUserCommentData,
      };
    case UsersTypes.CREATE_APP_USER_COMMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        appUserCommentData: action.payload.appUserCommentData,
      };
    case UsersTypes.CREATE_APP_USER_COMMENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        appUserCommentData: INITIAL_STATE.appUserCommentData,
      };

    // CASES UPDATE_APP_USER_COMMENT
    case UsersTypes.UPDATE_APP_USER_COMMENT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        appUserCommentData: INITIAL_STATE.appUserCommentData,
      };
    case UsersTypes.UPDATE_APP_USER_COMMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        appUserCommentData: action.payload.appUserCommentData,
      };
    case UsersTypes.UPDATE_APP_USER_COMMENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        appUserCommentData: INITIAL_STATE.appUserCommentData,
      };

    // CASES DELETE_APP_USER_COMMENT
    case UsersTypes.DELETE_APP_USER_COMMENT_REQUEST:
      return { ...state, loading: true, error: false };
    case UsersTypes.DELETE_APP_USER_COMMENT_SUCCESS:
      return { ...state, loading: false, error: false };
    case UsersTypes.DELETE_APP_USER_COMMENT_FAILURE:
      return { ...state, loading: false, error: true };
    
    // CASES GET APP USER SETTINGS
    case UsersTypes.GET_APP_USER_SETTINGS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        appUserSettingsData: INITIAL_STATE.appUserSettingsData,
      };
    case UsersTypes.GET_APP_USER_SETTINGS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        appUserSettingsData: action.payload.appUserSettingsData,
      };
    case UsersTypes.GET_APP_USER_SETTINGS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        appUserSettingsData: INITIAL_STATE.appUserSettingsData,
      };

    // CASES UPDATE USER SETTINGS
    case UsersTypes.UPDATE_APP_USER_SETTINGS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        appUserSettingsData: INITIAL_STATE.appUserSettingsData,
      };
    case UsersTypes.UPDATE_APP_USER_SETTINGS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        appUserSettingsData: action.payload.appUserSettingsData,
      };
    case UsersTypes.UPDATE_APP_USER_SETTINGS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        appUserSettingsData: INITIAL_STATE.appUserSettingsData,
      };
    
    // CASES DELETE USER SETTINGS
    case UsersTypes.DELETE_APP_USER_SETTINGS_REQUEST:
      return { ...state, loading: true, error: false };
    case UsersTypes.DELETE_APP_USER_SETTINGS_SUCCESS:
      return { ...state, loading: false, error: false };
    case UsersTypes.DELETE_APP_USER_SETTINGS_FAILURE:
      return { ...state, loading: false, error: true };

    // GET_APP_USER_FROM_DOCUMENT
    case UsersTypes.GET_APP_USER_IN_COMPANY_BY_DOCUMENT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        appUserInCompanyData: INITIAL_STATE.appUserInCompanyData,
      };
    case UsersTypes.GET_APP_USER_IN_COMPANY_BY_DOCUMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        appUserInCompanyData: action.payload.appUserInCompanyData,
      };
    case UsersTypes.GET_APP_USER_IN_COMPANY_BY_DOCUMENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        appUserInCompanyData: INITIAL_STATE.appUserInCompanyData,
      };

    // CASES APP  USER  CHECK  FACIAL  LIST  REQUEST
    case UsersTypes.APP_USER_CHECK_FACIAL_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        appUserCheckFacialList: INITIAL_STATE.appUserCheckFacialList,
      };
    case UsersTypes.APP_USER_CHECK_FACIAL_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        appUserCheckFacialList: action.payload.appUserCheckFacialList,
      };
    case UsersTypes.APP_USER_CHECK_FACIAL_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        appUserCheckFacialList: INITIAL_STATE.appUserCheckFacialList,
      };

    // CASES APP USER FACIAL REGISTER REQUEST
    case UsersTypes.APP_USER_FACIAL_REGISTER_REQUEST:
      return { ...state, loading: true, error: false };
    case UsersTypes.APP_USER_FACIAL_REGISTER_SUCCESS:
      return { ...state, loading: false, error: false };
    case UsersTypes.APP_USER_FACIAL_REGISTER_FAILURE:
      return { ...state, loading: false, error: true };

    // CASES APP_USER_SEND_USER_TRANSACTION_BY_EMAIL_REQUEST
    case UsersTypes.APP_USER_SEND_USER_TRANSACTION_BY_EMAIL_REQUEST:
      return { ...state, loading: true, error: false };
    case UsersTypes.APP_USER_SEND_USER_TRANSACTION_BY_EMAIL_SUCCESS:
      return { ...state, loading: false, error: false };
    case UsersTypes.APP_USER_SEND_USER_TRANSACTION_BY_EMAIL_FAILURE:
      return { ...state, loading: false, error: true };

    // CASES CREATE_SUPERVISOR_PROFILE_REQUEST
    case UsersTypes.CREATE_SUPERVISOR_PROFILE_REQUEST:
      return { ...state, loading: true, error: false };
    case UsersTypes.CREATE_SUPERVISOR_PROFILE_SUCCESS:
      return { ...state, loading: false, error: false };
    case UsersTypes.CREATE_SUPERVISOR_PROFILE_FAILURE:
      return { ...state, loading: false, error: true };

    // DELETE_CHARGE_REQUEST
    case UsersTypes.DELETE_CHARGE_REQUEST_REQUEST:
      return { ...state, loading: true, error: false };
    case UsersTypes.DELETE_CHARGE_REQUEST_SUCCESS:
      return { ...state, loading: false, error: false };
    case UsersTypes.DELETE_CHARGE_REQUEST_FAILURE:
      return { ...state, loading: false, error: false };

    // CREATE_APP_USER_ADDRESS_REQUEST
    case UsersTypes.CREATE_APP_USER_ADDRESS_REQUEST:
      return { ...state, loading: true };
    case UsersTypes.CREATE_APP_USER_ADDRESS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
      };
    case UsersTypes.CREATE_APP_USER_ADDRESS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    // DELETE_APP_USER_ADDRESS_REQUEST
    case UsersTypes.DELETE_APP_USER_ADDRESS_REQUEST:
      return { ...state, loading: true };
    case UsersTypes.DELETE_APP_USER_ADDRESS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
      };
    case UsersTypes.DELETE_APP_USER_ADDRESS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    default:
      return state;
  }
};

export default reducer;
